module.exports = __webpack_public_path__ + "img/curve_logo.9f543c0c.svg";